/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Whoever has been assigned to a given visit in Curai. Generally a licensed clinician.
 */
export interface UniversalClinicVisitAssignee {
  /** A unique identifier for the given assignee. */
  id: string;
  /** The full name of the assignee, including title. */
  name: string;
}
